var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-newsPage__wrapper" },
    [
      _c("div", { staticClass: "l-newsPage__grid-tools" }, [
        _c("div", [
          _vm._v("\n      " + _vm._s(_vm.translations["Showing"]) + " "),
          _c("span", [_vm._v(_vm._s(_vm.totalLoaded))]),
          _vm._v("\n      " + _vm._s(_vm.translations["articles"]) + "\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sorting" }, [
          _c(
            "div",
            {
              staticClass: "direction",
              on: {
                click: function($event) {
                  return _vm.toggleDirection()
                }
              }
            },
            [_c("img", { attrs: { src: "/images/sort.svg" } })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "type" },
            [
              _c("multiselect", {
                attrs: {
                  "deselect-label": "Can't remove this value",
                  "track-by": "code",
                  label: "label",
                  placeholder: "Sort by...",
                  options: _vm.sortOptions,
                  searchable: false,
                  "clear-on-select": false,
                  taggable: false,
                  "show-labels": false
                },
                scopedSlots: _vm._u([
                  {
                    key: "singleLabel",
                    fn: function(props) {
                      return [
                        _c("span", { staticClass: "option__desc" }, [
                          _c("span", { staticClass: "option__title" }, [
                            _vm._v(_vm._s(props.option.label))
                          ])
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selectedSortOption,
                  callback: function($$v) {
                    _vm.selectedSortOption = $$v
                  },
                  expression: "selectedSortOption"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "l-newsPage__grid", attrs: { id: "grid" } },
        [_vm._t("articles")],
        2
      ),
      _vm._v(" "),
      _vm.showLoadMore
        ? _c(
            "div",
            {
              staticClass:
                "l-newsPage__row l-newsPage__loadmore c-categoryGrid__loadMore"
            },
            [
              _c(
                "div",
                {
                  staticClass: "o-btn",
                  class: { loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.loadNextPage()
                    }
                  }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.buttonLabel) + "\n\n      "),
                  _c("inline-loader")
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "l-newsPage__row" }, [
        _c("div", { staticClass: "l-newsPage__counter" }, [
          _vm._v("\n      " + _vm._s(_vm.translations["Showing"]) + " "),
          _c("span", [_vm._v(_vm._s(_vm.totalLoaded))]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.translations["of"]) +
              " " +
              _vm._s(_vm.totalProducts) +
              "\n      " +
              _vm._s(_vm.translations["articles"]) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showLoader
          ? _c(
              "div",
              { staticClass: "c-categoryGrid__loader" },
              [_vm._t("loader")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }